export default __webpack_public_path__ + "static/media/image_industry.f7603a12.jpg";